module.exports = __webpack_public_path__ + "img/2_cheng.0cdd8cb4.png";